import React from "react";
import Dropzone from "react-dropzone";
function createMarkup(label) {
  return { __html: label };
}
export function renderField({
  input,
  label,
  placeholder,
  type,
  className,
  hiddenLabel,
  maxLength,
  meta: { touched, error, invalid },
  groupClasses = '',
}) {
  let labelClass = hiddenLabel ? "sr-only" : "";
  let groupClass = touched && invalid ? "form-group has-danger" : "form-group";
  groupClass += hiddenLabel ? "" : " show-label";
  groupClass += ` ${groupClasses}`;
  const placeholderText = placeholder || label;
  const extraProps = {};
  if (maxLength) {
    extraProps.maxLength = maxLength;
  }
  return (
    <div className={groupClass}>
      <label htmlFor={input.name} className={labelClass}>
        {label}
      </label>
      <input
        {...input}
        placeholder={placeholderText}
        className={className}
        type={type}
        {...extraProps}
      />
      {invalid && (
        <div className="form-control-feedback">
          {touched && error && <span>{error}</span>}
        </div>
      )}
    </div>
  );
}

export function renderDisabledField({
  input,
  label,
  type,
  className,
  hiddenLabel,
  meta: { touched, error, invalid }
}) {
  let labelClass = hiddenLabel ? "sr-only" : "";
  let groupClass = touched && invalid ? "form-group has-danger" : "form-group";
  groupClass += hiddenLabel ? "" : " show-label";
  return (
    <div className={groupClass}>
      <label htmlFor={input.name} className={labelClass}>
        {label}
      </label>
      <input
        {...input}
        placeholder={label}
        className={className}
        type={type}
        disabled
      />
      {invalid && (
        <div className="form-control-feedback">
          {touched && error && <span>{error}</span>}
        </div>
      )}
    </div>
  );
}

export function renderHidden({ input }) {
  return <input {...input} type="hidden" />;
}

export function renderCheckbox ({input, label, labelHTML, meta:{touched, error, invalid}, labelClassName}) {
  let groupClass = touched && invalid ? "form-check has-danger" : "form-check";
  const labelContent = labelHTML ? labelHTML : label;
  const labelClasses = labelClassName || 'u-textSize-18';
  return (
    <div className={groupClass}>
      <label className={`form-check-label ${labelClasses}`}>
        <input
          className="form-check-input"
          type="checkbox"
          {...input}
          checked={input.value}
        />
        <span>{labelContent}</span>
      </label>
    </div>
  );
}

export function renderSelect({
  input,
  meta: { touched, error, invalid },
  hiddenLabel,
  label,
  className,
  options,
  noPlaceholder
}) {
  let groupClass = touched && invalid ? "form-group has-danger" : "form-group";
  let labelClass = hiddenLabel ? "sr-only" : "";
  groupClass += hiddenLabel ? "" : " show-label";
  return (
    <div className={groupClass}>
      <label className={labelClass}>{label}</label>
      <select {...input} className={className}>
        {!noPlaceholder && <option value="">Please select one...</option>}
        {options?.map(option => (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {invalid && (
        <div className="form-control-feedback">
          {touched && error && <span>{error}</span>}
        </div>
      )}
    </div>
  );
}

export function renderTextarea({
  input,
  label,
  className,
  hiddenLabel,
  meta: { touched, error, invalid }
}) {
  let labelClass = hiddenLabel ? "sr-only" : "";
  let groupClass = touched && invalid ? "form-group has-danger" : "form-group";
  groupClass += hiddenLabel ? "" : " show-label";
  return (
    <div className={groupClass}>
      <label htmlFor={input.name} className={labelClass}>
        {label}
      </label>
      <textarea {...input} className={className} />
      {invalid && (
        <div className="form-control-feedback">
          {touched && error && <span>{error}</span>}
        </div>
      )}
    </div>
  );
}

export function renderFileUpload(field) {
  const files = field.input.value;
  return (
    <div>
      <Dropzone
        name={field.name}
        onDrop={(filesToUpload, e) => field.input.onChange(filesToUpload)}
      >
        <div>
          Try dropping some files here, or click to select files to upload.
        </div>
      </Dropzone>
      {field.meta.touched &&
        field.meta.error && <span className="error">{field.meta.error}</span>}
      {files &&
        Array.isArray(files) && (
          <ul>{files.map((file, i) => <li key={i}>{file.name}</li>)}</ul>
        )}
    </div>
  );
}
